import { useEffect } from "react";
import { getNoticeList } from "./services";
import { withNotifyContext, useNotifyContext } from "./hooks";
import { AutoNoti } from "./AutoNoti";
import { ManulNoti } from "./ManulNoti";

const Notify = () => {
  const {
    querys,
    appendNoticeList,
  } = useNotifyContext();

  useEffect(() => {
    if (querys?.pushPage != null) {
      getNoticeList(querys).then((list) => {
        if (list?.length) {
          appendNoticeList(list);
        }
      });
    }
  }, [querys]);

  return (
    <>
      <AutoNoti />
      <ManulNoti />
    </>
  );
};

export default withNotifyContext(Notify);
